// 3rd party
import { Directive } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[my-dt-header-options]'
})
export class MyDTHeaderOptionsDirective {

}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt-header-options.directive.ts